import PropTypes from 'prop-types';

const searchResultResource = PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    level: PropTypes.number,
    image: PropTypes.string,
    show_route: PropTypes.string.isRequired,
});


const searchResponseResource = PropTypes.shape({
    users: PropTypes.arrayOf(searchResultResource),
    countries: PropTypes.arrayOf(searchResultResource),
    states: PropTypes.arrayOf(searchResultResource),
    counties: PropTypes.arrayOf(searchResultResource),
    subcounties: PropTypes.arrayOf(searchResultResource),
    sites: PropTypes.arrayOf(searchResultResource),
    albums: PropTypes.arrayOf(searchResultResource),
});

export {
    searchResponseResource,
    searchResultResource,
}
